"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DeleteModal = void 0;

var _preact = require("preact");

var _Modal = require("@insided/shared/uikit/Modal");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var DeleteModal = function DeleteModal(_ref) {
  var type = _ref.type,
      onDelete = _ref.onDelete,
      onClose = _ref.onClose,
      eventsCount = _ref.eventsCount;
  return (0, _preact.h)(_Modal.Modal, {
    isOpen: true,
    size: "medium"
  }, (0, _preact.h)(_Modal.ModalHeader, {
    title: "Delete event type '".concat(type, "'?"),
    onClose: onClose
  }), (0, _preact.h)(_Modal.ModalBody, null, "If you delete an event type, it\u2019s gone for good.", ' ', eventsCount > 0 ? "This event type is used in ".concat(eventsCount, " event").concat(eventsCount > 1 ? 's' : '', ". These events will still be accessible on the events overview.") : ''), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_Button.default, {
    title: "Delete permanently",
    variant: "warning",
    onClick: onDelete,
    "data-track-type": "click",
    "data-element-name": "Delete button"
  }), (0, _preact.h)(_Button.default, {
    title: "Cancel",
    onClick: onClose,
    "data-track-type": "click",
    "data-element-name": "Cancel button"
  })));
};

exports.DeleteModal = DeleteModal;
var _default = DeleteModal;
exports.default = _default;